import React from 'react'
import { connect } from 'react-redux'
import { HashLink as Link } from 'react-router-hash-link';
import { Link as RouterLink } from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import HeaderNewClear from '../partials/HeaderNewClear.jsx'
import FooterNew from '../partials/FooterNew.jsx'
import LearnPagination from '../common/LearnPagination.jsx'
import { fetchWpPosts, fetchLatestWpPosts, fetchWpPostsByCategory } from '../../actions/learn'

import { UilCalendar, UilClockThree, UilAngleLeft, UilAngleRight, UilAngleDoubleLeft, UilAngleDoubleRight } from '@iconscout/react-unicons'

import imgHero from '../../images/hero-learn.png'
import imgSectionOne from '../../images/img_technical_01.png'
import imgLatest1 from '../../images/latest-img-1.jpg'
import imgLatest2 from '../../images/latest-img-2.jpg'
import imgLatest3 from '../../images/latest-img-3.jpg'

import { translate } from '../../helpers/global.js'

class Learn extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			currentPage: 1,
			itemsPerPage: 8,
			selectedCategory: 'all',
			isFromHeaderNavigation: false
		}
	}

	componentDidMount() {
		window.scrollTo(0, 0)
		
		// Listen for category filter events from header dropdown
		window.addEventListener('learnCategoryFilter', this.handleCategoryFilterEvent);
		
		// Check for category from localStorage (from header dropdown navigation)
		const storedCategory = localStorage.getItem('selectedLearnCategory');
		const isFromHeaderNav = localStorage.getItem('fromHeaderNavigation') === 'true';
		
		if (storedCategory) {
			// Set the category state and fetch posts for that category
			this.setState({ 
				selectedCategory: storedCategory,
				isFromHeaderNavigation: true 
			}, () => {
				this.props.fetchWpPostsByCategory(storedCategory, 1, this.state.itemsPerPage);
			});
			// Clear the stored category
			localStorage.removeItem('selectedLearnCategory');
		} else if (isFromHeaderNav) {
			// If we have the header navigation flag but no category, still apply the styling
			this.setState({ isFromHeaderNavigation: true });
		}
		
		if (isFromHeaderNav) {
			// Clear the header navigation flag
			localStorage.removeItem('fromHeaderNavigation');
		}
		
		if (!storedCategory && !isFromHeaderNav) {
			// Sync local state with Redux state if available
			const { wpPostsSelectedCategory } = this.props
			if (wpPostsSelectedCategory && wpPostsSelectedCategory !== this.state.selectedCategory) {
				this.setState({ selectedCategory: wpPostsSelectedCategory })
			}
			
			// Fetch initial posts for pagination
			this.props.fetchWpPosts(this.state.currentPage, this.state.itemsPerPage)
		}
		
		// Fetch latest posts for hero and sidebar
		this.props.fetchLatestWpPosts(4)
	}

	componentWillUnmount() {
		// Clean up event listener
		window.removeEventListener('learnCategoryFilter', this.handleCategoryFilterEvent);
	}

	handleCategoryFilterEvent = (event) => {
		const { category } = event.detail;
		
		// Check for header navigation flag when event is triggered
		const isFromHeaderNav = localStorage.getItem('fromHeaderNavigation') === 'true';
		if (isFromHeaderNav) {
			this.setState({ isFromHeaderNavigation: true });
			localStorage.removeItem('fromHeaderNavigation');
		}
		
		this.handleCategoryFilter(category);
	}

  handlePageChange = (page) => {
    this.setState({ currentPage: page })
    if (this.state.selectedCategory === 'all') {
      this.props.fetchWpPosts(page, this.state.itemsPerPage)
    } else {
      this.props.fetchWpPostsByCategory(this.state.selectedCategory, page, this.state.itemsPerPage)
    }
  }

  handleFirstPage = () => {
    this.setState({ currentPage: 1 })
    if (this.state.selectedCategory === 'all') {
      this.props.fetchWpPosts(1, this.state.itemsPerPage)
    } else {
      this.props.fetchWpPostsByCategory(this.state.selectedCategory, 1, this.state.itemsPerPage)
    }
  }

  handleLastPage = () => {
    const { wpPostsPagination } = this.props
    const totalPages = wpPostsPagination.get('lastPage') || 1
    this.setState({ currentPage: totalPages })
    if (this.state.selectedCategory === 'all') {
      this.props.fetchWpPosts(totalPages, this.state.itemsPerPage)
    } else {
      this.props.fetchWpPostsByCategory(this.state.selectedCategory, totalPages, this.state.itemsPerPage)
    }
  }

  handlePreviousPage = () => {
    const newPage = Math.max(1, this.state.currentPage - 1)
    this.setState({ currentPage: newPage })
    if (this.state.selectedCategory === 'all') {
      this.props.fetchWpPosts(newPage, this.state.itemsPerPage)
    } else {
      this.props.fetchWpPostsByCategory(this.state.selectedCategory, newPage, this.state.itemsPerPage)
    }
  }

  handleNextPage = () => {
    const { wpPostsPagination } = this.props
    const totalPages = wpPostsPagination.get('lastPage') || 1
    const newPage = Math.min(totalPages, this.state.currentPage + 1)
    this.setState({ currentPage: newPage })
    if (this.state.selectedCategory === 'all') {
      this.props.fetchWpPosts(newPage, this.state.itemsPerPage)
    } else {
      this.props.fetchWpPostsByCategory(this.state.selectedCategory, newPage, this.state.itemsPerPage)
    }
  }

  handleCategoryFilter = (category) => {
    // If category is null (from main Learn link), reset to 'all'
    const targetCategory = category === null ? 'all' : category;
    
    this.setState({ 
      selectedCategory: targetCategory,
      currentPage: 1 
    })
    
    if (targetCategory === 'all') {
      this.props.fetchWpPosts(1, this.state.itemsPerPage)
    } else {
      this.props.fetchWpPostsByCategory(targetCategory, 1, this.state.itemsPerPage)
    }
  }

  getTotalPages = () => {
    const { wpPostsPagination } = this.props
    return wpPostsPagination.get('lastPage') || 1
  }

  formatDate = (dateString) => {
    const date = new Date(dateString)
    return date.toLocaleDateString('en-US', { 
      month: 'short', 
      day: 'numeric', 
      year: 'numeric' 
    })
  }

  decodeHtmlEntities = (text) => {
    if (!text) return text
    const textArea = document.createElement('textarea')
    textArea.innerHTML = text
    return textArea.value
  }

  renderLatestBlogs = () => {
    const { latestWpPosts } = this.props
    // Skip the first post (used in hero) and take the next 3
    const latestPosts = latestWpPosts.slice(1, 4)
    
    return latestPosts.map((blog, index) => (
      <RouterLink 
        key={index} 
        to={`/learn-detail/${blog.get('id')}`} 
        className="latest-blog"
        style={{textDecoration: 'none', color: 'inherit'}}
      >
        <div className="latest-img">
          <img src={blog.get('thumbnail') || imgLatest1} alt={blog.get('title')} />
        </div>
        <div className="latest-text">
          <h5>{blog.get('title')}</h5>
          <p className="hero-blog-desc">
            <span><UilCalendar size="18" />{this.formatDate(blog.get('date'))}</span>
            <span><UilClockThree size="18" />{blog.get('read_duration')}</span>
          </p>
        </div>
      </RouterLink>
    ))
  }

  renderBlogCards = () => {
    const { wpPosts } = this.props
    
    return wpPosts.map((blog, index) => (
      <RouterLink 
        key={index} 
        to={`/learn-detail/${blog.get('id')}`} 
        className="blog-card"
        style={{textDecoration: 'none', color: 'inherit'}}
      >
        <div className="blog-card-img">
          <img src={blog.get('thumbnail') || imgLatest1} alt={blog.get('title')} />
        </div>
        <div className="blog-card-content">
          <h5>{blog.get('title')}</h5>
          <label>{blog.get('categories') && blog.get('categories').size > 0 ? this.decodeHtmlEntities(blog.get('categories').get(0)) : 'Article'}</label>
          <p className="blog-card-desc">"{blog.get('short_description')}"</p>
          <p className="hero-blog-info">
            <span><UilCalendar size="18" />{this.formatDate(blog.get('date'))}</span>
            <span><UilClockThree size="18" />{blog.get('read_duration')}</span>
          </p>
        </div>
      </RouterLink>
    ))
  }

  renderHTML = (rawHTML) => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } })

  render() {
    const { globalGetLanguages, wpPosts, wpPostsPagination, latestWpPosts } = this.props
    const currentPage = wpPostsPagination.get('page') || 1
    const perPage = wpPostsPagination.get('perPage') || 8
    const total = wpPostsPagination.get('total') || 0
    const lastPage = wpPostsPagination.get('lastPage') || 1
    
    // Get the latest post for hero section from separate latest posts
    const latestPost = latestWpPosts && latestWpPosts.size > 0 ? latestWpPosts.get(0) : null
    
    return (
      <div id="homepage">
        <HeaderNewClear isOnStatusFor="is-on" />
        
        <div className={`banner ai ${this.state.isFromHeaderNavigation ? 'hide' : ''}`}>
          <section>
            <div className="ban-text learn">
              <div className="row">
                <RouterLink 
                  to={latestPost ? `/learn-detail/${latestPost.get('id')}` : '#'} 
                  className="col-md-7"
                  style={{textDecoration: 'none', color: 'inherit', cursor: latestPost ? 'pointer' : 'default'}}
                >
                  {latestPost && (
                    <>
                      <img className="hero-blog-img" src={latestPost.get('thumbnail') || imgHero} alt="Hero" />
                      <h2 className="hero-blog-title">
                        {latestPost.get('title')}
                      </h2>
                      <p className="hero-blog-desc">
                        <span><UilCalendar size="18" />{this.formatDate(latestPost.get('date'))}</span>
                        <span><UilClockThree size="18" />{latestPost.get('read_duration')}</span>
                      </p>
                    </>
                  )}
                </RouterLink>
                <div className="col-md-5 latest-container">
                  <h5>Latest</h5>
                  <div className="latest-list">
                    {this.renderLatestBlogs()}
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>

        <div className={`section-white ${this.state.isFromHeaderNavigation ? 'padding-no-hero' : ''}`} style={{position: 'relative', overflow: 'hidden'}}>
          <section className='position-relative'>
            <h2 className="blog-post-text">
              Blog Post
            </h2>
            <div className="category-list">
              <button 
                className={this.state.selectedCategory === 'all' ? 'active' : ''} 
                onClick={() => this.handleCategoryFilter('all')}
              >
                All
              </button>
              <button 
                className={this.state.selectedCategory === 'customer-story' ? 'active' : ''} 
                onClick={() => this.handleCategoryFilter('customer-story')}
              >
                Customer Stories
              </button>
              <button 
                className={this.state.selectedCategory === 'ai-and-talent' ? 'active' : ''} 
                onClick={() => this.handleCategoryFilter('ai-and-talent')}
              >
                AI & Talent
              </button>
              <button 
                className={this.state.selectedCategory === 'product-and-updates' ? 'active' : ''} 
                onClick={() => this.handleCategoryFilter('product-and-updates')}
              >
                Product & Updates
              </button>  
            </div>
            <div className="blog-post-list">
              {this.renderBlogCards()}
            </div>
            <LearnPagination
              currentPage={currentPage}
              totalPages={lastPage}
              total={total}
              perPage={perPage}
              onPageChange={this.handlePageChange}
              onFirstPage={this.handleFirstPage}
              onPreviousPage={this.handlePreviousPage}
              onNextPage={this.handleNextPage}
              onLastPage={this.handleLastPage}
            />
          </section>
        </div>
        
        <FooterNew />
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  globalGetLanguages: state.globalGetLanguages,
  wpPosts: state.wpPosts,
  wpPostsPagination: state.wpPostsPagination,
  wpPostsError: state.wpPostsError,
  wpPostsSelectedCategory: state.wpPostsSelectedCategory,
  latestWpPosts: state.latestWpPosts,
  latestWpPostsError: state.latestWpPostsError
})

const mapDispatchToProps = {
  fetchWpPosts,
  fetchLatestWpPosts,
  fetchWpPostsByCategory
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Learn))
